<template>
    <div>
      <button @click="ignoreTransaction">Ignore Transaction</button>
    </div>
  </template>
  
  <script>
  export default {
    props: ['transactionId'],
    methods: {
      ignoreTransaction() {
        // Send POST request to mark this.transactionId as ignored
      }
    }
  };
  </script>
  